export function toPlainString(num) {
  return ('' + +num).replace(/(-?)(\d*)\.?(\d*)e([+-]\d+)/,
    function (a, b, c, d, e) {
      return e < 0
        ? b + '0.' + Array(1 - e - c.length).join(0) + c + d
        : b + c + d + Array(e - d.length + 1).join(0);
    });
}


export const walletShortFormer = (wallet) => {
  return `${wallet.substring(0, 4) + "..." + wallet.substring(wallet.length - 3)}`
}

export function formatNumberWithDecimals(value, decimalPlaces) {
  const parsedValue = parseFloat(value);

  if (!isNaN(parsedValue) && Number.isInteger(parsedValue)) {
    return parsedValue.toString(); // Plain value for integers
  } else if (!isNaN(parsedValue)) {
    return parsedValue.toFixed(decimalPlaces); // Fixed decimal places for non-integer numbers
  } else {
    return "Invalid Number"; // Return an error message for non-numeric values
  }
}
export  function addingSameTargetPrice(data) {
  const groupedByPrice = data.reduce((acc, item) => {
    if (!acc[item.target_price]) {
      acc[item.target_price] = [];
    }
    acc[item.target_price].push(item);
    return acc;
  }, {});
  const result = Object.values(groupedByPrice).map((group, index) => {

    if (group.length === 1) {

      return group[0];
    } else {
      const sum =  group.reduce((acc, item,) => acc + parseInt(item.amount), 0);
      return { ...group[0], amount: sum };
    }
  });
  return result
}
